module.exports = __webpack_public_path__ + "static/snow-accumulation-legend-in-f53e18c8265b3ebb2bfa78455d3c56af.svg";